import { Box, Flex, HStack, Icon, Switch, Text } from '@chakra-ui/react';
import { TbCarOff } from 'react-icons/tb';
import { useReportingFilters } from '../ReportingFiltersContext';

const ExcludeEvsToggle = () => {
    const { excludeEvs, toggleExcludeEvs } = useReportingFilters();

    return (
        <Flex align="center" justify="space-between" cursor="pointer" onClick={toggleExcludeEvs}>
            <HStack spacing={3}>
                <Icon as={TbCarOff as React.ElementType} boxSize={5} color="gray.500" />
                <Box>
                    <Text fontSize="sm" fontWeight="semibold" color="gray.800">
                        Exclude EVs
                    </Text>
                    <Text fontSize="xs" color="gray.500">
                        Exclude Tesla, Lucid, and Rivian from stats
                    </Text>
                </Box>
            </HStack>
            <Switch isChecked={excludeEvs} pointerEvents="none" colorScheme="blue" size="md" />
        </Flex>
    );
};

export default ExcludeEvsToggle;
